import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestBody,
  OpalApi,
  OpalApiResponseDocument,
} from '../../schema'

type Operation = 'UpdateMomentV3'
export type UpdateMomentV3RequestBody = OpalApiRequestBody<Operation>

type UpdateMomentV3 = OpalApi<Operation, 200>
type ResponseData = OpalApiResponseDocument<'UpdateMomentV3', 201>

export const updateMoment: UpdateMomentV3 = async ({
  params,
  requestBody,
}: Parameters<UpdateMomentV3>[0] = {}) => {
  const momentId = params?.path?.moment_id
  if (!momentId) {
    throw new Error('moment_id is a required path parameter')
  }

  const url = new URL(`/moments/v3/${momentId}`, window.location.origin)
  const query = params?.query
  url.search = queryString({
    'expose[meta][access]': String(!!query?.expose?.meta?.access),
    ...(query?.expose?.moment?.meta != null && {
      'expose[moment][meta]': query.expose.moment.meta,
    }),
  })

  return HttpClient()
    .patch<ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
